import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react";
import cadviewer from "cadviewer";
import classNames from "classnames";
import { useCallback, useContext, useEffect, useState } from "react";
import { useAlert } from "react-alert";
import { Panel, PanelGroup, PanelResizeHandle } from "react-resizable-panels";
import { Link, useNavigate } from "react-router-dom";
import { RightAction, SideBarLeftPanel, Tooltip } from "../../components";
import { CadviewerContext } from "../../context/Cadviewer.Context";
import { User } from "../../types";
import useConfig from "../../demos/hooks/useConfig";

const roles = {
  user: "Member",
  admin: "Administrator",
};

export const Users = () => {
  const { config } = useConfig();

  const [leftPanelOpen, setLeftPanelOpen] = useState(
    config.defaultLeftPanelOpen
  );
  const [isLoading, setIsLoading] = useState(true);
  const [users, setUsers] = useState<User[]>([]);
  const alert = useAlert();
  const navigate = useNavigate();
  const { user } = useContext(CadviewerContext);

  const getUsers = useCallback(async () => {
    if (!user) return;
    setIsLoading(true);
    const headers = new Headers();
    console.log({ Bearer: `Bearer ${user?.token}`, user });
    headers.append("Authorization", `Bearer ${user?.token}`);
    // fix cors
    headers.append("Access-Control-Allow-Origin", "*");
    headers.append("Content-Type", "application/json");
    headers.append("Accept", "application/json");
    try {
      const response = await fetch(
        config.ServerBackEndUrl +
          (config.ServerBackEndUrl.endsWith("/") ? "" : "/") +
          "users",
        {
          method: "GET",
          headers,
        }
      );
      const data = await response.json();
      // check if status is not 200
      console.log({ data, response });
      if (!response.ok) {
        alert.error(data.error);
      } else {
        setUsers(data.data);
      }
    } catch (error: any) {
      console.log({ error });
      // setFormData(form => ({...form, error: "Something went wrong. Please try again later."}))
      alert.error("Something went wrong. Please try again later.");
    } finally {
      setIsLoading(false);
    }
  }, [user]);

  const changeRole = useCallback(
    async (id: number, role: string) => {
      if (!user) return;
      const headers = new Headers();
      headers.append("Authorization", `Bearer ${user?.token}`);
      headers.append("Content-Type", "application/json");
      headers.append("Accept", "application/json");
      try {
        const response = await fetch(
          config.ServerBackEndUrl +
            (config.ServerBackEndUrl.endsWith("/") ? "" : "/") +
            "users/" +
            id +
            "/change-role",
          {
            method: "PUT",
            headers,
            body: JSON.stringify({ role }),
          }
        );
        const data = await response.json();
        if (!response.ok) {
          alert.error(data.error);
        } else {
          alert.success(data.message);
          getUsers();
        }
      } catch (error: any) {
        alert.error("Something went wrong. Please try again later.");
      }
    },
    [user]
  );

  const changeUserStatus = useCallback(
    async (id: number, status: number) => {
      if (!user) return;
      const headers = new Headers();
      headers.append("Authorization", `Bearer ${user?.token}`);
      headers.append("Content-Type", "application/json");
      headers.append("Accept", "application/json");
      try {
        const response = await fetch(
          config.ServerBackEndUrl +
            (config.ServerBackEndUrl.endsWith("/") ? "" : "/") +
            "users/" +
            id +
            "/enable-disable",
          {
            method: "PUT",
            headers,
            body: JSON.stringify({ is_enabled: status }),
          }
        );
        const data = await response.json();
        if (!response.ok) {
          alert.error(data.error);
        } else {
          alert.success(data.message);
          getUsers();
        }
      } catch (error: any) {
        alert.error("Something went wrong. Please try again later.");
      }
    },
    [user]
  );

  const deleteUser = useCallback(
    async (id: number) => {
      if (!user) return;
      const headers = new Headers();
      headers.append("Authorization", `Bearer ${user?.token}`);
      headers.append("Content-Type", "application/json");
      headers.append("Accept", "application/json");
      try {
        const response = await fetch(
          config.ServerBackEndUrl +
            (config.ServerBackEndUrl.endsWith("/") ? "" : "/") +
            "users/" +
            id,
          {
            method: "DELETE",
            headers,
          }
        );
        const data = await response.json();
        if (!response.ok) {
          alert.error(data.error);
        } else {
          alert.success(data.message);
          getUsers();
        }
      } catch (error: any) {
        alert.error("Something went wrong. Please try again later.");
      }
    },
    [user]
  );

  useEffect(() => {
    getUsers();
  }, [getUsers, user]);

  console.log({ user });
  //
  // if (user?.role !== "admin") {
  //     return <div className="h-screen flex justify-center items-center">
  //         <div className="text-center">
  //             <h1 className="text-4xl font-bold">403</h1>
  //             <p className="text-lg">You are not authorized to view this page</p>
  //         </div>
  //     </div>
  // }

  return (
    <div
      className={classNames({
        "h-screen max-h-screen overflow-y-hidden": true,
        "min-h-screen h-full w-full": true,
        "transition-[grid-template-columns] duration-300 ease-in-out": true,
      })}
    >
      <PanelGroup
        autoSaveId="main-content-panel"
        direction="horizontal"
        onLayout={(sizes) => cadviewer.cvjs_hideOnlyPop()}
      >
        {leftPanelOpen && (
          <>
            <Panel
              /*onResize={(size) => cadviewer.cvjs_hideOnlyPop()}*/ order={1}
              defaultSize={config.leftPaneDefaultWidth}
            >
              {/* Left Pane: put icon for open it like panel */}
              <SideBarLeftPanel
                leftPanelOpen={leftPanelOpen}
                setLeftPanelOpen={setLeftPanelOpen}
              />
            </Panel>
            {/* @ts-ignore */}

            <PanelResizeHandle className="w-2 bg-gray-300 relative">
              <div
                className="h-8 w-4 bg-gray-300 flex items-center justify-center"
                style={{
                  zIndex: 1000,
                  position: "absolute",
                  bottom: 0,
                  top: "calc(50% - 16px)",
                }}
              >
                <svg
                  width="20px"
                  height="32px"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g id="Interface / Drag_Horizontal">
                    <g id="Vector">
                      <path
                        d="M14 18C14 18.5523 14.4477 19 15 19C15.5523 19 16 18.5523 16 18C16 17.4477 15.5523 17 15 17C14.4477 17 14 17.4477 14 18Z"
                        stroke="#fff"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M8 18C8 18.5523 8.44772 19 9 19C9.55228 19 10 18.5523 10 18C10 17.4477 9.55228 17 9 17C8.44772 17 8 17.4477 8 18Z"
                        stroke="#fff"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M14 12C14 12.5523 14.4477 13 15 13C15.5523 13 16 12.5523 16 12C16 11.4477 15.5523 11 15 11C14.4477 11 14 11.4477 14 12Z"
                        stroke="#fff"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M8 12C8 12.5523 8.44772 13 9 13C9.55228 13 10 12.5523 10 12C10 11.4477 9.55228 11 9 11C8.44772 11 8 11.4477 8 12Z"
                        stroke="#fff"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M14 6C14 6.55228 14.4477 7 15 7C15.5523 7 16 6.55228 16 6C16 5.44772 15.5523 5 15 5C14.4477 5 14 5.44772 14 6Z"
                        stroke="#fff"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M8 6C8 6.55228 8.44772 7 9 7C9.55228 7 10 6.55228 10 6C10 5.44772 9.55228 5 9 5C8.44772 5 8 5.44772 8 6Z"
                        stroke="#fff"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </g>
                  </g>
                </svg>
              </div>
            </PanelResizeHandle>
          </>
        )}
        <Panel order={2} /*onResize={(size) => cadviewer.cvjs_hideOnlyPop()}*/>
          {/* Main conntent */}
          <div className="h-screen max-h-screen overflow-y-hidden flex flex-col">
            <div className="w-full bg-gray-100 min-h-20 flex justify-between items-center px-14 py-2">
              <Tooltip text={config.hambugerMenuTooltip}>
                <button
                  className="-ml-14 mr-5 bg-sidebar-hamburger-background  text-sidebar-hamburger-icon p-3"
                  onClick={() => setLeftPanelOpen((state : any) => !state)}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={1.5}
                    stroke="currentColor"
                    className="w-6 h-6"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5"
                    />
                  </svg>
                </button>
              </Tooltip>
              <Link to={"/"} className={"flex"}>
                {config.topBarLogo && (
                  <img
                    src={config.topBarLogo}
                    alt="CADViewer Logo"
                    className="h-11"
                  />
                )}
                {!leftPanelOpen && (
                  <img
                    src={"https://cadviewer.com/images/cadviewer/cv-logo.gif"}
                    alt="CADViewer Logo"
                    className="ml-2 h-11"
                  />
                )}
              </Link>
              <div className="flex-1 flex flex-col justify-start items-start ml-4">
                <div>
                  <h4>
                    <b>Users Management</b>
                  </h4>
                </div>
              </div>
              <RightAction />
            </div>
            {isLoading ? (
              <div className={"h-full w-full flex justify-center items-center"}>
                <div className={"flex flex-col justify-center items-center"}>
                  <svg
                    className="animate-spin h-8 w-8 text-primary-500 mb-2"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <circle
                      className="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      strokeWidth="4"
                    ></circle>
                    <path
                      className="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                    ></path>
                  </svg>
                  Users Loading...
                </div>
              </div>
            ) : (
              <main
                className={classNames({
                  "h-full relative flex-1  overflow-x-hidden": true,
                })}
              >
                <div className="px-8 sm:px-12 lg:px-20 py-8">
                  <div className="sm:flex sm:items-center">
                    <div className="sm:flex-auto">
                      <h1 className="text-base font-semibold leading-6 text-gray-900">
                        Users
                      </h1>
                      <p className="mt-2 text-sm text-gray-700">
                        A list of all the users in your organization
                      </p>
                    </div>
                    {/*<div className="mt-4 sm:ml-16 sm:mt-0 sm:flex-none">*/}
                    {/*    <button*/}
                    {/*        type="button"*/}
                    {/*        className="block rounded-md bg-primary-600 px-3 py-2 text-center text-sm font-semibold text-white shadow-sm hover:bg-primary-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-600"*/}
                    {/*    >*/}
                    {/*        Add new user*/}
                    {/*    </button>*/}
                    {/*</div>*/}
                    <div>
                      <div>
                        <button
                          onClick={() => {
                            navigate("/");
                          }}
                          className={`inline-flex items-center gap-x-1.5 rounded-md bg-primary-600 px-2.5 py-2 text-sm font-semibold text-white shadow-sm hover:bg-primary-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-600 mr-2
							        ${
                        config.helperMethodsActionSize === "small"
                          ? " text-xs my-1 mr-1 py-[2px] px-1"
                          : config.helperMethodsActionSize === "large"
                          ? " text-base my-2 mr-2 py-2 px-3"
                          : " text-sm my-2 mr-2 py-1 px-3"
                      }`}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            strokeWidth={1.5}
                            stroke="currentColor"
                            className="size-6"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              d="m2.25 12 8.954-8.955c.44-.439 1.152-.439 1.591 0L21.75 12M4.5 9.75v10.125c0 .621.504 1.125 1.125 1.125H9.75v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21h4.125c.621 0 1.125-.504 1.125-1.125V9.75M8.25 21h8.25"
                            />
                          </svg>
                          <span>{config.settingsGoHomepageButtonText}</span>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className="mt-8 flow-root">
                    <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                      <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
                        <table className="min-w-full divide-y divide-gray-300">
                          <thead>
                            <tr>
                              <th
                                scope="col"
                                className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-0"
                              >
                                Name
                              </th>
                              <th
                                scope="col"
                                className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                              >
                                Username
                              </th>
                              <th
                                scope="col"
                                className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                              >
                                Status
                              </th>
                              <th
                                scope="col"
                                className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                              >
                                Role
                              </th>
                              <th
                                scope="col"
                                className="relative py-3.5 pl-3 pr-4 sm:pr-0"
                              >
                                <span className="sr-only">Edit</span>
                              </th>
                            </tr>
                          </thead>
                          <tbody className="divide-y divide-gray-200 bg-white">
                            {users.map((user) => (
                              <tr key={user.email}>
                                <td className="whitespace-nowrap py-5 pl-4 pr-3 text-sm sm:pl-0">
                                  <div className="flex items-center">
                                    <div className="h-11 w-11 flex-shrink-0">
                                      <img
                                        alt=""
                                        src={user?.avatar_url || "/avatar.jpg"}
                                        className="h-11 w-11 rounded-full"
                                      />
                                    </div>
                                    <div className="ml-4">
                                      <div className="font-medium text-gray-900">
                                        {user.first_name} {user.last_name}
                                      </div>
                                      <div className="mt-1 text-gray-500">
                                        {user.email}
                                      </div>
                                    </div>
                                  </div>
                                </td>
                                <td className="whitespace-nowrap px-3 py-5 text-sm text-gray-500">
                                  <div className="text-gray-900">
                                    {user.username}
                                  </div>
                                </td>
                                <td className="whitespace-nowrap px-3 py-5 text-sm text-gray-500">
                                  {user.is_enabled === 1 ? (
                                    <span className="inline-flex items-center rounded-md bg-green-50 px-2 py-1 text-xs font-medium text-green-700 ring-1 ring-inset ring-green-600/20">
                                      Active
                                    </span>
                                  ) : (
                                    <span className="inline-flex items-center rounded-md bg-red-50 px-2 py-1 text-xs font-medium text-red-700 ring-1 ring-inset ring-red-600/20">
                                      Disabled
                                    </span>
                                  )}
                                </td>
                                <td className="whitespace-nowrap px-3 py-5 text-sm text-gray-500">
                                  {roles[user.role]}
                                </td>
                                <td className="relative whitespace-nowrap py-5 pl-3 pr-4 text-right text-sm font-medium sm:pr-0">
                                  <Menu
                                    as="div"
                                    className="relative inline-block text-left"
                                  >
                                    <div>
                                      <MenuButton className="flex items-center rounded-full bg-gray-100 text-gray-400 hover:text-gray-600 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2 focus:ring-offset-gray-100">
                                        <span className="sr-only">
                                          Open options
                                        </span>
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          fill="none"
                                          viewBox="0 0 24 24"
                                          strokeWidth={1.5}
                                          stroke="currentColor"
                                          className="size-6"
                                        >
                                          <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            d="M12 6.75a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5ZM12 12.75a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5ZM12 18.75a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5Z"
                                          />
                                        </svg>
                                      </MenuButton>
                                    </div>

                                    <MenuItems
                                      transition
                                      className="absolute right-0 z-10 mt-2 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in"
                                    >
                                      <div className="py-1">
                                        <MenuItem>
                                          <span
                                            onClick={() =>
                                              changeRole(
                                                user.id,
                                                user.role == "user"
                                                  ? "admin"
                                                  : "user"
                                              )
                                            }
                                            className="block px-4 py-2 text-sm text-gray-700 data-[focus]:bg-gray-100 data-[focus]:text-gray-900"
                                          >
                                            {user.role == "user"
                                              ? "Make Admin"
                                              : "Make Member"}
                                          </span>
                                        </MenuItem>
                                        <MenuItem>
                                          <span
                                            onClick={() =>
                                              changeUserStatus(
                                                user.id,
                                                user.is_enabled === 1 ? 0 : 1
                                              )
                                            }
                                            className="block px-4 py-2 text-sm text-gray-700 data-[focus]:bg-gray-100 data-[focus]:text-gray-900"
                                          >
                                            {user.is_enabled === 1
                                              ? "Disable this user"
                                              : "Enable this user"}
                                          </span>
                                        </MenuItem>
                                        <MenuItem>
                                          <span
                                            onClick={() => deleteUser(user.id)}
                                            className="block w-full px-4 py-2 text-left text-sm text-gray-700 data-[focus]:bg-gray-100 data-[focus]:text-gray-900"
                                          >
                                            Delete
                                          </span>
                                        </MenuItem>
                                      </div>
                                    </MenuItems>
                                  </Menu>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </main>
            )}
          </div>
        </Panel>
      </PanelGroup>
    </div>
  );
};
